/**
 * Утилиты для форматирования времени
 */

/**
 * Форматирует секунды в читаемый формат времени
 * @param seconds - количество секунд
 * @returns строка в формате "Xм Yс" или "Xс"
 */
export const formatTime = (seconds?: number): string => {
  if (seconds == null || !Number.isFinite(seconds) || seconds <= 0) return '-';
  const totalSeconds = Math.round(seconds);
  if (totalSeconds < 60) return `${totalSeconds}с`;
  const mins = Math.floor(totalSeconds / 60);
  const secs = totalSeconds % 60;
  return `${mins}м ${secs}с`;
};

/**
 * Форматирует секунды для отображения времени на вопрос
 * @param seconds - количество секунд
 * @returns строка в формате "Xс" или "Xм Yс"
 */
export const formatQuestionTime = (seconds?: number): string => {
  return formatTime(seconds);
};

/**
 * Форматирует секунды в формат для среднего времени
 * @param seconds - количество секунд (может быть дробным)
 * @returns строка в формате "Xс" или "X.1с"
 */
export const formatAverageTime = (seconds?: number): string => {
  if (seconds == null || !Number.isFinite(seconds) || seconds <= 0) return '-';
  const rounded = Math.round(seconds * 10) / 10;
  if (rounded < 60) return `${rounded}с`;
  const mins = Math.floor(rounded / 60);
  const secs = Math.round((rounded % 60) * 10) / 10;
  return `${mins}м ${secs}с`;
};
